import request from "@/utils/request"

// 常见问题列表
export const faq = function(query) {
  return request('get', '/api/faq', query)
}

// 常见问题详情
export const getFaqByType = function(query) {
  return request('get', '/api/faq/getFaqByType', query)
}

// 获取目录
export const faqCatalog = function(query) {
  return request('get', '/api/faq/catalog', query)
}